import { useEmployeeFormContext } from 'src/components/enterprise/features/Employee/components/Form/EmployeeFormProvider/useEmployeeFormContext';
import { emailDisabledInfo } from 'src/components/common/EmailInput/constants';

type UseEmailControlWrapperReturn = {
  disabled: boolean;
  disabledInfo: string;
};

export function useEmailControlWrapper(): UseEmailControlWrapperReturn {
  const { isEditPage } = useEmployeeFormContext();

  return {
    disabled: isEditPage,
    disabledInfo: emailDisabledInfo,
  };
}
